__turbopack_context__.v({
  "actionBar": "OrganizerCard-module-scss-module__4AM5JG__actionBar",
  "buttonGroup": "OrganizerCard-module-scss-module__4AM5JG__buttonGroup",
  "content": "OrganizerCard-module-scss-module__4AM5JG__content",
  "title": "OrganizerCard-module-scss-module__4AM5JG__title",
  "unnamedContent": "OrganizerCard-module-scss-module__4AM5JG__unnamedContent",
});
